module.exports = __webpack_public_path__ + "img/75724.9373ecde.svg";